module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_resort-6be93904428085c38c4e88a4b4936949.webp";